module.exports = __webpack_public_path__ + "img/mastercard.f7553b5a.svg";